export const APP_VARIABLES = {
    // LocalStorage item names
    currentUser: 'COM.CURRENT_USER',
    currentDonate: 'COM.CURRENT_DONATE'
};
